(function( $ ){

    const initial_scrolltop = $( window ).scrollTop();
    const run_animations = () => {
        let $to_animate     = $( '.animate__onscroll:not(.animate__animated)' );
        $to_animate         = $to_animate.filter( function(){
            return $(this).offset().top > $(window).height() + initial_scrolltop;
        });
        if( ! $to_animate.length ){
            return;
        }
        let $next = $to_animate.eq(0);
        if( $( window ).scrollTop() + $( window ).height() > $next.offset().top ){
            let animation_class = $next.attr( 'data-animation' );
            $next.addClass( 'animate__animated animate__slow ' + animation_class );
        }
    }

    // $( window ).on( 'scroll', () => {
    //     if( $( window ).width() > 768 ){
    //         run_animations();
    //     }
    // });
    // run_animations();

})( jQuery );